import { ropoloRequest } from '../axios';

const getRoles = async (vendorId?: string) =>
  (
    await ropoloRequest.identityRolesList({
      vendorId,
    })
  )?.data;

const removeRole = async (roleId: string) => (await ropoloRequest.identityRolesDelete(roleId))?.data;

const getRolePermissions = async (roleId: string) => (await ropoloRequest.identityRolesDetail(roleId))?.data;

export { getRoles, getRolePermissions, removeRole };
